<div class="content-wrapper table-full-bx">
  <div class="page-content">

      <div class="row">
          <div class="col-lg-12">
              <div class="ibox ">  
                   <div class="ibox-body">
                         <div class="iboxcontent">
                                  <h3>Job Template</h3>                                              
                         </div>
                          <div class="selected-template" hidden>
                                  <img src="assets/images/ic_completed.svg" class="ht">
                              <div class="content">
                                  <h6>You used a previous job as a template</h6>
                                  <p class="para8">Edit the information to reflect changes needed for your new job post</p>
                              </div>
                             
                          </div>
                        <form [formGroup]="form" (ngSubmit)="onSubmit(addMore)">
                          <!-- Step 1 -->
                            <div class="templatesection">
                                <h4 class="heading-4">Job details<a href="javascript:void(0)" [routerLink]="'/jobs/add/'" [queryParams]="{jobId:allJobs?.JobPost?.id,isStepper:1 }"  *ngIf="showEditButton"><img src="assets/images/ic_edit.svg" class="et"> </a></h4>
                                <div class="stepsdes">
                                    <h6 class="heading-6">Job Title</h6>
                                    <p class="para-6 cap">{{allJobs?.JobPost?.jobTitle || "-"}}</p>
                                </div>
                                <div class="stepsdes">
                                    <h6 class="heading-6">Location</h6>
                                    <p class="para-6">{{allJobs?.JobPost?.workPlaceLocation || "-"}}</p>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Category</h6>
                                    <p class="para-6">{{allJobs?.JobPost?.categoryName || "-"}}</p>
                                </div>
                                <div class="stepsdes basicdetails p-0" *ngIf="allJobs?.subCategory != ''">
                                    <h6 class="heading-6">Specilization</h6>
                                    <p class="para6"><span *ngFor="let subcat of allJobs?.subCategory; let i=index;">{{subcat.subCategoryName}}</span> </p>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Employment type</h6>
                                    <p class="para-6">{{allJobs?.JobPost?.EmploymentTypesName || "-"}}</p>
                                </div>


                                <div class="stepsdes">
                                    <h6 class="heading-6">Schedule</h6>
                                    <p class="para-6">{{allJobs?.JobPost?.schedulesName || "-"}}</p>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Description</h6>
                                    <p class="para-6">{{allJobs?.JobPost?.description || "-"}}</p>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Skills</h6>
                                    <ul class="addedskills" *ngIf="allJobs?.JobPostSkills != null">
                                        <li *ngFor="let skill of allJobs?.JobPostSkills; let i=index;">{{skill?.skillsName}}</li>
                                    </ul>
                                    <span *ngIf="allJobs?.JobPostSkills == null">-</span>

                                </div>
                            </div>
                            <!-- end -->
                            <div class="templatesection">
                                <h4 class="heading-4">Pay options<a  href="javascript:void(0)" [routerLink]="'/jobs/edit'" [queryParams]="{jobId:allJobs?.JobPost?.id,isStepper:2 }" *ngIf="showEditButton"><img src="assets/images/ic_edit.svg" class="et"> </a></h4>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Pay</h6>
                                
                                    <p class="para-6" *ngIf="allJobs?.JobPost?.payOption == 'Range'"> 
                                        ${{allJobs?.JobPost?.minimum || "0"}} To ${{allJobs?.JobPost?.maximum || "0"}} {{allJobs?.JobPost?.rate}}</p>
                                    <p class="para-6" *ngIf="allJobs?.JobPost?.payOption != 'Range'">
                                        ${{allJobs?.JobPost?.price || "0"}} {{allJobs?.JobPost?.rate}}</p>
                                </div>
                                <div class="stepsdes">
                                    <h6 class="heading-6">Benefits</h6>
                                    <ul class="addedskills" *ngIf="allJobs?.JobPostBenefits != null">
                                        <li *ngFor="let ben of allJobs?.JobPostBenefits; let i=index;">{{ben?.benefitsName}}</li>
                                    </ul>
                                    <span *ngIf="allJobs?.JobPostBenefits == null">-</span>
                                </div>
                            </div>

                            <!-- End -->
                            <div class="templatesection">
                                <h4 class="heading-4">Screening questions <a  href="javascript:void(0)" [routerLink]="'/jobs/edit'" [queryParams]="{jobId:allJobs?.JobPost?.id,isStepper:3 }" *ngIf="showEditButton"><img src="assets/images/ic_edit.svg" class="et"> </a></h4>
                                <div  *ngFor="let qus of allJobs?.JobPostAddQuestions">
                                    <div class="stepsdes">
                                        <div class="customradiobox">
                                            <h6 class="heading-6">{{qus.screening_question_name == null ? qus.title : qus.screening_question_name}}</h6>
                                            <div class="custom_radio m-0" *ngIf="qus?.responseType == 1">
                                                <div class="set-width" *ngIf="qus.answer == ''">
                                                    <input type="text" disabled readonly placeholder="Please enter" class="form-control text-capitalize">
                                                </div>
                                                <div *ngIf="qus.answer != ''">{{qus.answer}}</div>
                                              
                                                    
                                                </div>    
                                                <div class="custom_radio m-0" *ngIf="qus?.responseType == 0">
                                                    <input type="radio" id="relocate1" name="relocate" [checked]="qus.answer == 'Yes'|| qus.answer == 'yes/no'" readonly disabled><label for="relocate">Yes</label>
                                                    <input type="radio" id="relocate2" name="relocate" [checked]="qus.answer == 'no'|| qus.answer == 'yes/no'" readonly disabled><label for="relocate">No</label>
                                               </div>
                                            <!-- <div class="custom_radio m-0">
                                                <input type="radio" id="relocate1" name="relocate" [checked]="qus.answer == 'Yes'|| qus.answer == 'yes/no'" readonly disabled><label for="relocate">Yes</label>
                                                <input type="radio" id="relocate2" name="relocate" [checked]="qus.answer == 'no'|| qus.answer == 'yes/no'" readonly disabled><label for="relocate">No</label>
                                            </div> -->
                                        </div>
                                    </div>  
                                </div>
                            </div>


                            <!-- Step -->
                            <div class="templatesection">
                                <h4 class="heading-4">Preferences<a  href="javascript:void(0)" [routerLink]="'/jobs/edit'" [queryParams]="{jobId:allJobs?.JobPost?.id,isStepper:4 }" *ngIf="showEditButton"><img src="assets/images/ic_edit.svg" class="et"> </a></h4>

                                <div class="stepsdes">

                                    <p class="para-6">This job is eligible for the following</p>
                                    
                                    <ul class="addedskills">
                                        <li *ngFor="let jobEl of allJobs?.jobEligibleFor; let i=index;">{{jobEl?.eligibles_name}}</li>
                                    </ul>
                                    <h6 class="heading-6">Benefits</h6>
                                    <ul class="addedskills" *ngIf="allJobs?.JobPostBenefits != null">
                                        <li *ngFor="let ben of allJobs?.JobPostBenefits; let i=index;">{{ben?.benefitsName}}</li>
                                    </ul>
                                    <span *ngIf="allJobs?.JobPostBenefits == null">-</span>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6 questiontext">Does the covid vaccination certificate required?</h6>
                                    <p>{{allJobs?.JobPost?.vaccinationCerificate == 1 ? "Yes" : "No"}}</p>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6">Travel requirements</h6>
                                    <ul class="addedskills">
                                        <li *ngIf="allJobs?.JobPost?.travelRequirementsName != null">{{allJobs?.JobPost?.travelRequirementsName}}</li>
                                    </ul>
                                    <span *ngIf="allJobs?.JobPost?.travelRequirementsName == null">-</span>

                                </div>
                                <div class="stepsdes">
                                    <h6 class="heading-6 questiontext">How many people do you need to hire for this job opening?</h6>
                                    <p>{{allJobs?.JobPost?.noOfPeopleRequired || "-"}}</p>
                                </div>
                                <div class="stepsdes">
                                    <h6 class="heading-6 questiontext">How quickly do you need to hire?</h6>
                                    <ul class="addedskills">
                                        <li *ngIf="allJobs?.JobPost?.Hiresrequired != null">{{allJobs?.JobPost?.Hiresrequired}}</li>
                                    </ul>
                                    <span *ngIf="allJobs?.JobPost?.Hiresrequired == null">-</span>
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6 questiontext">Daily updates will be sent to</h6>
                                    <p><span *ngFor="let mail of allJobs?.JobPostNotificationEmails;" style="display: inline-block;vertical-align: middle;margin-right: 3px;" class="comma">{{mail.emailId || "-"}}</span> </p> 
                                </div>

                                <div class="stepsdes">
                                    <h6 class="heading-6 questiontext">Let potential candidates call you directly about this job</h6>
                                    <p>{{allJobs?.JobPost?.phoneNumber || "-"}}</p> 
                                </div>
                            </div>
                        <!-- End -->
                            <div class="col-sm-12" *ngIf="showEditButton">
                            <div class="custom-control custom-checkbox ">
                                <input type="checkbox" class="custom-control-input" id="customBox1" formControlName="isAccepted" [checked]="form.value.isAccepted ==1" (change)="form.value.isAccepted ==1">
                                <label for="customBox1" class="custom-control-label para9">By pressing confirm, you are agree that this job will be posted and applications will be processed in accordance with Honorvet’s  <span class="orange"><a  href="/cookies" routerLink="/cookies" target="_blank">Cookie Policy,</a> <a href="/privacy" routerLink="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" routerLink="/terms" target="_blank">Terms of Service</a>.</span></label>
                                <div class="text-danger" *ngIf="form.controls['isAccepted'].hasError('required') && showError">
                                    *Please accept the Terms of Service & Privacy Policy.
                                </div>
                            </div>
                                <a href="javascript:void(0);" class="planbtn greyBtn" routerLink="/jobs/post-job">Back</a>
                                <input type="submit" value="Continue" class="planbtn fill"/> 
                            </div>
                        </form>  
                    </div>
                </div>                         
            </div>  
        
        </div>  <!--main div end   -->
   </div>
</div>
<!-- End -->

<ng-template #addMore>
    <div class="modal-body">
      <!-- <figure>
        <img src="../../../../assets/images/tick_icon.gif" alt="git icon"/>
      </figure>
      <p class="ft-wt">Congratulations!</p> -->
      <p>This job is already Existed. if you want to post the similar new job then need to edit this job.</p>
  </div>
  </ng-template> 